import { useExport } from './useExport'
import {
  createPlanExport,
  getPlanExport,
  type CreatePlanExportRequest,
} from '@/api/planExports'

/**
 * Hook to export assortment plans list.
 * Uses the generic useExport hook with plan-specific endpoints.
 */
export function useExportPlans() {
  const exportHook = useExport<CreatePlanExportRequest>({
    createExportFn: createPlanExport,
    getExportFn: getPlanExport,
    filenamePrefix: 'assortment-plans',
  })

  return {
    ...exportHook,
    // Alias for backwards compatibility
    exportPlans: exportHook.startExport,
  }
}

// Re-export types for convenience
export type { ExportStatus, ExportState } from './useExport'
